export default function () {
  /**
   * @type {*|[]|NodeListOf<HTMLElementTagNameMap[string]>|NodeListOf<Element>}
   */
  const appearedElement = document.querySelectorAll('.c-appeared');

  /**
   * appearedEffectClass
   * @type {string}
   */
  const appearedEffectClass = 'c-appeared--done';

  /**
   * Option
   * @type {{threshold: number}}
   */

  const options = {
    threshold: [0.01, 0.25, 0.99],
  };

  /**
   * observer
   * @type {IntersectionObserver}
   */
  const appearedObserver = new IntersectionObserver(appearedIntersection, options);

  /**
   * Observe targets
   * @return void
   */
  appearedElement.forEach((target) => {
    appearedObserver.observe(target);
  });

  /**
   * appearedIntersection
   * @param entries
   * @return void
   */
  function appearedIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add(appearedEffectClass);
        appearedObserver.unobserve(entry.target);
      }
    });
  }
}
